<script lang="ts">
    import {Component, mixins, Prop, toNative} from 'vue-facing-decorator'
    import BookingPageBase from '~src/components/parts/bookingPageBase.src'
    import {FlightStoreMixin} from '@/mixins/FlightStoreMixin.vue'
    import {callComponentMethod} from '~/utils/vue-class-helpers'

    @Component({mixins: [BookingPageBase]})
    export class FlightBookingPageLayout extends mixins(FlightStoreMixin) {
        @Prop() specialRemarkRM

        prepareBookTourists(tourists, specifiedTouristBookingFields, includeOptionalTourists = false) {
            const newTourists = callComponentMethod(
                this,
                BookingPageBase,
                'prepareBookTourists',
                tourists,
                specifiedTouristBookingFields,
                includeOptionalTourists
            )
            return newTourists.map((tourist, index) => {
                const mealTypesSeatAllowance = this.mealTypesSeatAllowance[index],
                    frequentFlyerCard = this.frequentFlyerCard[index]
                return {
                    ...tourist,
                    ...(mealTypesSeatAllowance?.mealTypeCode && {mealTypeCode: mealTypesSeatAllowance.mealTypeCode}),
                    ...(mealTypesSeatAllowance?.seatAllocationCode && {
                        seatAllocationCode: mealTypesSeatAllowance.seatAllocationCode,
                    }),
                    ...(frequentFlyerCard && {
                        bonusCard: {
                            ...{number: frequentFlyerCard.number, airlineCode: frequentFlyerCard.airlineCode},
                        },
                    }),
                }
            })
        }

        get mealTypesSeatAllowance() {
            return flightsStore.mealTypesSeatAllowance
        }

        get frequentFlyerCard() {
            return flightsStore.frequentFlyerCard
        }

        get productSearchPageName() {
            return 'flights'
        }

        get productConfirmationPageName() {
            return 'flightConfirmation'
        }

        get productName() {
            return 'flight'
        }

        get productBookingPageName() {
            return 'flightBooking'
        }

        get corporatePolicyType() {
            return 'flight'
        }

        get startDate() {
            return flightsRuntimeStore.routes[0].date
        }
    }

    export default {...toNative(FlightBookingPageLayout), ssrRender: BookingPageBase.ssrRender}
</script>
